import { gql } from '@apollo/client';

export const pageVerificationView = gql`
  query pageVerificationView($page: Int!, $amount: Int!, $field: String!, $sort: String!, $filters: [FilterInput!], $csv: Boolean!) {
    pageVerificationView(grid: { amount: $amount, page: $page, field: $field, filters: $filters, sort: $sort, csv: $csv }) {
      data {
        VerifyId
        BarCodeNumber
        Department
        Status
        owner
        VerifyDate
        Type
        source
        UserId
        departmentId
        allComments
        transferTo
      }
      count
    }
  }
`;

export const pageEOneUpdates = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageEOneUpdates(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        updateId
        assetNumber
        description1
        description2
        description3
        updateStatus
        accountNumber
        additionalRemarks
        additionalRemarks2
        additionalRemarks3
        assetItemCurrentQuantity
        assetItemOriginalQuantity
        barCode
        assetNumber
        businessUnit
        categoryCode6
        companyNumber
        dateAcquired
        department
        equipmentStatus
        itemFunction
        location
        locationDescription
        majorAccountingClass
        majorEquipmentClass
        manufacturer
        newOrUsed
        originalPurchaser
        parentNumber
        physicalOwner
        poNumber
        serialNumber
        updateDate
        updateType
        toDeptId
      }
    }
  }
`;

export const pageTransfers = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageTransfers(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        updateId
        assetNumber
        description1
        description2
        description3
        updateStatus
        accountNumber
        additionalRemarks
        additionalRemarks2
        additionalRemarks3
        assetItemCurrentQuantity
        assetItemOriginalQuantity
        barCode
        assetNumber
        businessUnit
        categoryCode6
        companyNumber
        dateAcquired
        department
        equipmentStatus
        itemFunction
        location
        locationDescription
        majorAccountingClass
        majorEquipmentClass
        manufacturer
        newOrUsed
        originalPurchaser
        parentNumber
        physicalOwner
        poNumber
        serialNumber
        updateDate
        updateType
        toDeptId
        oitDCId
        dcName
        toDeptName
        requestFY
      }
    }
  }
`;

export const auditBarcodesQuery = gql`
  query readCommentsByBarcode($barCode: String!, $type: String) {
    readCommentsByBarcode(barCode: $barCode, type: $type) {
      comment
      createdOn
      createdBy
    }
  }
`;

export const statusEmailQuery = gql`
  query sendStatusEmails($barcode: String!, $assetNumber: String!, $process: String!) {
    sendStatusEmails(barcode: $barcode, assetNumber: $assetNumber, process: $process)
  }
`;

export const pageSalvage = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageSalvage(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        salvageId
        assetNumber
        barCode
        businessUnit
        serialNumber
        department
        description1
        description2
        description3
        additionalRemarks
        additionalRemarks2
        additionalRemarks3
        location
        physicalOwner
        updateStatus
        salvageFormDispositionCode
        enterpriseOneDispositionCode
        disposalApproval
        disposalApprovalDate
        pcaApproval
        pcaApprovalDate
        psmApproval
        psmApprovalDate
        maApproval
        maApprovalDate
      }
    }
  }
`;
